module.exports = __webpack_public_path__ + "img/payments.7a77db06.jpg";